import { css } from '@emotion/react'
import { colors } from './scalar'

export default css`
  input {
    ::placeholder {
      color: ${colors.lightGrey};
    }
  }

  input[type='date'] {
    ::-webkit-datetime-edit-month-field {
      text-transform: uppercase;
      color: ${colors.lightGrey};
    }
    ::-webkit-datetime-edit-day-field {
      text-transform: uppercase;
      color: ${colors.lightGrey};
    }
    ::-webkit-datetime-edit-year-field {
      text-transform: uppercase;
      color: ${colors.lightGrey};
    }
    ::-webkit-calendar-picker-indicator {
      background: transparent;
    }
    ::-webkit-datetime-edit-text {
      color: ${colors.lightGrey};
    }
    ::-webkit-inner-spin-button {
      display: none;
    }
  }

  input[type='date'].notempty,
  input[type='date']:focus {
    ::-webkit-datetime-edit-month-field {
      color: ${colors.black};
    }
    ::-webkit-datetime-edit-day-field {
      color: ${colors.black};
    }
    ::-webkit-datetime-edit-year-field {
      color: ${colors.black};
    }
    ::-webkit-datetime-edit-text {
      color: ${colors.black};
    }
  }
`
